import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieConsentDialogComponent } from '../../cookie-consent/ui/cookie-consent-dialog.component';

@Component({
  selector: 'app-course-layout',
  imports: [RouterOutlet, CookieConsentDialogComponent],
  template: `
    <main>
      <router-outlet></router-outlet>

      <app-cookie-consent-dialog />
    </main>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseLayout {}
